import React from 'react';

export const PrivacyPolicyPage: React.FC = () => {
    return (
        <>
            <h1>Privacy policy</h1>
            <br />
            <section id="definitions">
                <p>
                    This Privacy Policy sets out the policies and practices regarding information or data that is
                    received and stored relating to users of foxCaves, operated by Doridian (Mark Dietzer) (hereafter
                    referred to as the 'Site').
                </p>
                <p>
                    Please read this privacy policy carefully as your usage of the website and operation of your
                    expressly signify that you agree to this policy and that you agree to the handling of the limited
                    the limited data we collect in accordance with this policy.{' '}
                    <strong>
                        If you do not agree to this policy, you should not use this site or the services provided by
                        this site.
                    </strong>
                </p>
            </section>
            <section id="user-info">
                <div className="page-header">
                    <h2>User Information</h2>
                </div>
                <p>
                    When you visit this Site or contact us via email, we will collect and electronically store
                    information obtained from you or your browser, for example: your IP address and host name; date and
                    time of your access to our site; the website from which you were referred to our site. This
                    information is gathered to help us improve the content on our site and make it more useful to our
                    visitors, and also for security purposes relating to abuse of our network and site.
                </p>
                <p>
                    We collect limited personally identifying information upon voluntary consent being given by you,
                    such as your email address, email header information and IP address. Additionally, you may be
                    requested for extra voluntary information when making a financial donation or other transaction via
                    our third-party service providers (For example, PayPal).
                </p>
            </section>
            <section id="cookies">
                <div className="page-header">
                    <h2>Cookies</h2>
                </div>
                <p>
                    The Site may use cookies to store and occasionally track information for essential operation of the
                    site and to make your experience more personalized. Cookies are small pieces of data that are stored
                    by a user's Web browser on the user's hard drive. Cookies can remember what information a user
                    accesses on one Web page to simplify subsequent interactions with that Web site by the same user or
                    to use the information to streamline the user's transactions on related Web pages. This makes it
                    easier for a user to move from Web page to Web page and to complete commercial transactions over the
                    Internet. Most major Web browsers are set up so that they will initially accept cookies, but you may
                    modify your computers preferences to issue you an alert when a cookie is downloaded, or to disable
                    the ability of third parties to download a cookie to you. If you choose to reject all cookies, there
                    are areas of this Site and other websites that may not function properly.
                </p>
            </section>
            <section id="liability">
                <div className="page-header">
                    <h2>Use of Information</h2>
                </div>
                <p>
                    By using the Site and/or its services, you (the Visitor/User) expressly agree that foxCaves may use
                    any information collected from you for the express purpose of providing Customer Service,
                    informational and service updates and other email communications as required. The Site will not
                    disclose any information to a third-party under any circumstances with the express exception of
                    being presented with a valid court order from a UK court with relation to a copyright or other legal
                    violation or in the case of an authorized (by you) financial transaction with a trusted third-party
                    (For example, PayPal).
                </p>
                <p>
                    The Site is not responsible and cannot be held liable for any information that you provide to a
                    third-party that may be found via the site. This Site does not control, monitor or endorse the
                    practices or policies of any third-party websites. Where applicable, you should seek to read the
                    policies of any third-party providers that may have an advertising banner or link on this Site.
                </p>
                <p>By signing up or establishing email communication with us, you agree to the following:</p>
                <ul>
                    <li>
                        that the Site has your permission to collect the email address you use on our services and
                        related personal information voluntarily supplied;
                    </li>
                    <li>
                        that the Site has your permission to transfer your collected information to trusted
                        third-parties with your authorization;
                    </li>
                    <li>
                        that the Site has your permission to contact you using the collected information for the
                        purposes of important email communication if and when required
                    </li>
                </ul>
            </section>
            <section id="disclosure">
                <div className="page-header">
                    <h2>Disclosure</h2>
                </div>
                <p>
                    The Site will not disclose or use any of your personally identifiable information except to the
                    extent as defined in this Privacy Policy, or if you give prior written consent for the usage of your
                    data, or under special circumstances, such as when we are presented with a valid UK court order, or
                    when we feel that disclosing the information to the appropriate authorities is required to maintain
                    our rights and terms and conditions or to identify, contact or bring legal action against someone
                    who may be violating the Site Terms and Conditions.
                </p>
            </section>
            <section id="misc">
                <div className="page-header">
                    <h2>Revisions to this policy</h2>
                </div>
                <p>
                    foxCaves reserves the right, at its sole and absolute discretion, to revise, amend or modify this
                    privacy policy to the fullest extent permitted by law. Changes to this policy will be effective by
                    posting revisions on the Site and giving 30 days notice, where possible, before implementing new
                    revisions.
                </p>
            </section>
        </>
    );
};
